/* this depends on DefineConstantsWebpackPlugin */

const React = require('react')
const scope = typeof window !== 'undefined' ? window : global
const instance = scope[NAMESPACE] || (scope[NAMESPACE] = {})
const key = `context-${MICROFRONTEND_UUID}`
let context
if (!Object.prototype.hasOwnProperty.call(instance, key)) {
  context = React.createContext({})
  instance[key] = context
} else {
  context = instance[key]
}

module.exports.changeVirtualPath = path => (__webpack_public_path__ = path)

module.exports.FronthubContext = context
module.exports.FronthubProvider = context.Provider
module.exports.FronthubConsumer = context.Consumer
